export default __webpack_public_path__ + "static/media/Purchase Management.6e23c835.png";